import Button from "@edaz/edazkit/Button/index";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Row } from "react-bootstrap";

export interface CollapsibleProps {
  title: string;
  collapse: string;
  collapsed: boolean;
  icon: IconType;
  toggle: () => void;
  children: React.ReactNode;
}

const Collapsible = observer((props: CollapsibleProps) => {
  const { collapsed, collapse, children, icon, title, toggle } = props;

  return (
    <>
      <Row className="d-flex justify-content-between align-items-center" onClick={toggle} style={{ cursor: "pointer" }}>
        <Col className="d-flex align-items-center">
          <div
            className="bg-secondary d-flex align-items-center justify-content-center rounded-circle text-white mr-3"
            style={{ height: 40, width: 40, minWidth: 40 }}>
            <Icon icon={icon} width={20} height={20} />
          </div>
          <h6 className="mb-0 text-break">{title}</h6>
        </Col>
        <Col xs="auto" className="mx-0">
          <Row className="mx-0">
            {!collapsed && (
              <Button
                variant="link"
                className="d-none d-md-block m-0 mr-2 py-0 px-1 text-wrap text-left text-body box-shadow-none link-underline font-weight-bold">
                {collapse}
              </Button>
            )}
            <Button variant="light" className="m-0 p-2 box-shadow-none" size={"sm"}>
              <Icon
                style={{ transform: collapsed ? "rotate(180deg)" : "none" }}
                icon={IconType.ArrowSubmenuTop}
                width={10}
                height={10}
                className="d-block"
              />
            </Button>
          </Row>
        </Col>
      </Row>
      {!collapsed && <>{children}</>}
    </>
  );
});

export default Collapsible;
